<template>
    <q-layout
            view="lhh LpR lff"
            container
            class="shadow-2 rounded-borders window-height"
            :class="$q.dark.isActive ? 'bg-grey-9' : 'bg-grey-3'"
    >
        <q-header class="bg-primary">
            <q-toolbar>
                <q-toolbar-title>Отчет по импорту лидов</q-toolbar-title>
                <q-btn @click="downloadReport" :loading="isLoading" :disable="isLoading" color="red" class="q-mr-md">Скачать отчет</q-btn>
                <q-btn flat @click="drawerRight = !drawerRight" round dense icon="menu"/>
            </q-toolbar>
        </q-header>


        <q-drawer
                side="right"
                v-model="drawerRight"
                bordered
                :width="308"
                :breakpoint="500"
        >
            <q-scroll-area class="fit">
                <div class="q-pa-sm" style="padding-bottom: 40px">
                    <q-date v-model="filters.created_at.value" range mask="YYYY-MM-DD" class="q-mb-sm"/>

                    <q-btn-toggle
                        class="q-mb-sm fullWidth"
                        v-model="separate"
                        toggle-color="primary"
                        :options="[
                              {label: 'Общая', value: false},
                              {label: 'По дням', value: 'day'}
                            ]"
                        @update:modelValue="saveSettings"
                    />

                    <q-btn-toggle
                        class="q-mb-sm fullWidth"
                        v-model="type"
                        toggle-color="primary"
                        :options="[
                                {label: 'First click', value: 'first'},
                                {label: 'Last click', value: 'last'},
                              ]"
                        unelevated
                        @update:modelValue="saveSettings"
                    />

                    <q-select
                            v-if="settings.partners"
                            class="q-mb-md"
                            filled
                            v-model="filters.partner.value"
                            multiple
                            :options="objectToOptions(settings.partners)"
                            counter
                            use-chips
                            stack-label
                            label="По указанным партнерам"
                            hint="Выбрано"
                            behavior="dialog"
                            use-input
                    />

                    <q-btn-toggle
                            class="q-mb-sm fullWidth"
                            v-model="filters.valid.value"
                            toggle-color="primary"
                            :options="[
                              {label: 'Все', value: null},
                              {label: 'Валидные', value: 1},
                              {label: 'Не валидные', value: 0}
                            ]"
                            unelevated
                            @update:modelValue="saveSettings"
                    />

                    <q-checkbox v-model="filters.uniqueCurrent.value" toggle-indeterminate label="Уникальный (текущий сайт)"/>
                    <q-checkbox v-model="filters.uniqueAll.value" toggle-indeterminate label="Уникальный (все сайты)"/>

                    <div class="memo">
                        Чекбокс имеет 3 состояния - влючен (да), выключен (нет) и неизвестен (-)
                    </div>

                </div>
                <div class="q-pa-sm fixed-bottom bg-white">
                    <q-btn class="full-width" :loading="isLoading" :disabled="isLoading" color="primary"
                           @click="saveSettings" label="Построить отчет"/>
                </div>
            </q-scroll-area>
        </q-drawer>

        <q-page-container>
            <q-page style="padding-top: 30px" class="q-pa-md" v-if="data.records && data.columns">
                <div>
                    <q-table
                            title="Общая статистика импорта"
                            :rows="data.records"
                            :columns="data.columns"
                            row-key="name"
                            :pagination="{rowsPerPage: 0}"
                    />
                </div>

            </q-page>
            <q-page v-else style="padding-top: 30px" class="q-pa-md">
                <q-banner inline-actions class="text-white bg-red">
                    Выберите даты и постройте отчет.
                </q-banner>

            </q-page>

        </q-page-container>
    </q-layout>

</template>

<script setup>

import {onMounted, reactive, ref} from "vue";
import {ajax, ajaxDownload, objectToOptions} from "@/assets/js/functions";
import '@/assets/css/style.css'


const isLoading = ref(true)
const drawerRight = ref(true)
const settings = ref({})
const separate = ref(false)
const data = ref({})
const type = ref('first')

const filters = reactive({
    created_at: {
        value: new Date().toISOString().split('T')[0],
        column: 'created_at',
        operator: 'BETWEEN_DATES'
    },
    partner: {
        value: null,
        column: 'partner_id',
        operator: 'IN'
    },
    valid: {
        value: null,
        column: 'valid',
        operator: '='
    },
    uniqueCurrent: {
        value: null,
        column: 'unique_current',
        operator: '='
    },
    uniqueAll: {
        value: null,
        column: 'unique_all',
        operator: '='
    }

})

onMounted(async () => {
    ajax({ action: "getImportReportSettings" }, (data) => {
        settings.value = data
        isLoading.value = false
    })

    saveSettings()
})

const saveSettings = () => {
    isLoading.value = true
    ajax({
        action: "getImportReport",
        params: filters,
        type: type.value,
        separate: separate.value
    }, (response) => {
        data.value = response
        isLoading.value = false
        console.log(response)
    })
}

const downloadReport = () => {
    isLoading.value = true

    let createdAtValue = filters.created_at.value;
    if (typeof createdAtValue === 'object' && createdAtValue !== null && 'from' in createdAtValue && 'to' in createdAtValue) {
        createdAtValue = `${createdAtValue.from} - ${createdAtValue.to}`;
    }
    ajaxDownload({
        action: "downloadImportReport",
        type: type.value,
        params: filters
    }, () => {
        isLoading.value = false
    }, 'importReport_'+ createdAtValue +'.csv')
}

</script>

<style scoped>
.totalCount{
    font-size: 14px;
    font-weight: 400;
    margin: 20px 0;
}
</style>